import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminDashboard.css';

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(open => !open);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={`admin-dashboard ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Aurora Tech</h2>
          <p>Admin Portal</p>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/admin/dashboard" end className="nav-link">
            <span className="nav-icon">📊</span>
            <span>Dashboard</span>
          </NavLink>
          <NavLink to="/admin/dashboard/clients" className="nav-link">
            <span className="nav-icon">👥</span>
            <span>Clients</span>
          </NavLink>
          <NavLink to="/admin/dashboard/projects" className="nav-link">
            <span className="nav-icon">📦</span>
            <span>Projects & Uploads</span>
          </NavLink>
          <NavLink to="/admin/dashboard/analytics" className="nav-link">
            <span className="nav-icon">📈</span>
            <span>Analytics</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.name?.charAt(0)}</div>
            <div className="user-details">
              <div className="user-name">{user?.name}</div>
              <div className="user-email">{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="btn btn-secondary btn-block">
            Logout
          </button>
        </div>
      </aside>

      <div className="sidebar-overlay" onClick={closeSidebar} />

      <main className="admin-content">
        <div className="mobile-header">
          <button className="hamburger" onClick={toggleSidebar} aria-label="Toggle menu">☰</button>
          <div className="mobile-title">Admin</div>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
